/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Title2Inputs */

const en_coinvestments_editemail_title2 = /** @type {(inputs: Coinvestments_Editemail_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send Email`)
};

/**
* | output |
* | --- |
* | "Send Email" |
*
* @param {Coinvestments_Editemail_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_title2 = /** @type {((inputs?: Coinvestments_Editemail_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_title2(inputs)
});
export { coinvestments_editemail_title2 as "coInvestments_editEmail_title" }